/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { CalendarNav, Eventcalendar, MbscCalendarDayData, MbscCalendarEvent, MbscCalendarEventData, MbscEventClickEvent, MbscEventCreateEvent, MbscEventDragEvent, MbscResource, Popup, setOptions, localeEn, localeHi, localeEs } from '@mobiscroll/react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Styles from './stemsche.module.css';
import { Box, Button, IconButton, Typography } from '@mui/material';
import {ReactComponent as AddCircle} from './../../assets/SVG/add-circle.svg';
import {ReactComponent as Eye} from './../../assets/SVG/eye.svg';
import { showConfirmationModal } from '../ConfirmationModel';
import { ReactComponent as Camera } from './../../assets/SVG/camera copy.svg';
import { ReactComponent as CheckBox } from './../../assets/SVG/CheckboxGrantAccess.svg';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { createDrug, createEmptyFSDetailResults, deleteHormone, deleteMed, DrugPostRequest, DrugSchema, FollicularStudyDetails, FollicularStudyResultsList, getDrugDetails, getFSResults, getStim, getTestResults, scheduleFA, Stim, StimulationEvent, StimulationMedication, StimulationTabPermission, TestResult } from '../../pages/Stim/helper.stim';
import { useAlert } from '../alertProvider';
import { useLoader } from '../loaderProvider/loader';
import { convertDateToISOWithOffset, convertToLocalDateTime, convertUTCToLocalTime, formatDateToLocalYYYYMMDD, getNumberOfDays } from '../../services/time';
import DefaultLoader from '../defaultLoader';
import { EventcalendarBase } from '@mobiscroll/react/dist/src/core/components/eventcalendar/eventcalendar';
import EventModel from '../../pages/Stim/eventModal';
import AddDrugModal from '../../pages/Stim/addDrugModel';
import CreateDrugModal from '../../pages/Stim/createMedModal';
import CreateHormoneModal from '../../pages/Stim/createHormone';
import { PaginatedResponse, User } from '../../types';
import { usePatientContext } from '../SubPatinetProvider';
import HormoneValueModal from '../../pages/Stim/createHormoneTestModal';
import FolliculerModal from '../../pages/Stim/follicularModal';
import FollicularImageModal from './FollicularImageModal';
import { convertDateToDDMMYYYY } from '../../utils/commonUtils';
import { getCurrentUser } from '../../services/userService';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import Editicon from '../../assets/SVG/edit-2 (1).svg'
import { getButtonStates } from '../../utils/permissionService';
import { useTranslation } from 'react-i18next';

// Set Mobiscroll locale dynamically based on i18n language
import i18n from '../../services/i18n';
type MobiscrollLocaleType = typeof localeEn | typeof localeHi | typeof localeEs;
const mobiscrollLocales: Record<string, MobiscrollLocaleType> = {
  en: localeEn,
  hi: localeHi,
  es: localeEs
};
setOptions({
  theme: 'ios',
  themeVariant: 'light',
  locale: mobiscrollLocales[i18n.language] || localeEn
});

interface StimulationSchedularProps {
  id: number,
  height?: string
  isEdit?: boolean
}

export const StimulationSchedular: React.FC<StimulationSchedularProps> = ({ id, height, isEdit }) => {
  const { showLoader, hideLoader } = useLoader();
  const { t, i18n: i18nInstance } = useTranslation('stimulation_config');

  // Update Mobiscroll locale if language changes
  React.useEffect(() => {
    setOptions({
      locale: mobiscrollLocales[i18nInstance.language] || localeEn
    });
  }, [i18nInstance.language]);
  const [stim, setStim] = useState<MbscResource[] | null>(null);
  const [stimEvents, setStimEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [trigger, setTrigger] = useState<MbscResource[] | null>(null);
  const [triggerEvents, setTriggerEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [hormone, setHormone] = useState<MbscResource[] | null>(null);
  const [hormoneEvents, setHormoneEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [editable, setEditable] = useState<boolean>(false);

  const [follicularStudyEvents, setFollicularStudyEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularImageEvents, setFollicularImageEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularDetailsEvents, setFollicularDetailsEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularETEvents, setFollicularETEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularSizeEvents, setFollicularSizeEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [maxFollicleSize, setMaxFollicleSize] = useState<number>(20);

  const [firstDate, setFirstDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();

  const [fullScreen, showFullScreen] = useState<boolean>(false);

  const [selectedStim, setSelctedStim] = useState<Stim | null>();

  const [focusEvent, setFocusEvent] = useState<MbscEventCreateEvent | null>();
  const [focusEventCal, setFocusEventCal] = useState<MbscCalendarEventData | null>();

  const [isNewEvent, setIsNewEvent] = useState<boolean>(true);
  const [showEventModal, setShowEventModal] = useState<boolean>(false);
  const [showDrugModal, setShowDrugModal] = useState<boolean>(false);
  const [showCreateDrugModal, setShowCreateDrugModal] = useState<boolean>(false);
  const [showCreateHormoneModal, setShowCreateHormoneModal] = useState<boolean>(false);
  const [showHormoneValueModal, setShowHormoneValueModal] = useState<boolean>(false);
  const [showFolliculareModal, setShowFollicularModal] = useState<boolean>(false);
  const [showFolliculareImageModal, setShowFollicularImageModal] = useState<boolean>(false);
  const [follicularModalMode, setFollicularModalMode] = useState<'view' | 'edit'>('edit');
  const [events, setEvents] = useState<MbscCalendarEvent[] | undefined>();
  const [refresh, doRefresh] = useState<boolean>(false);
  const [type, setType] = useState<'Trigger' | 'Stim' | null>(null);
  const [isOpuAvailable, setOpuAvailable] = useState<boolean>(false);
  const [selectionDate, setSelectionDate] = useState<undefined | string>(undefined);

  const { patientId } = usePatientContext();
  const { addAlert } = useAlert();

  const { canView, canAdd, canEdit } = getButtonStates('Clinical', 'Stimulation', 'Chart', 'female');
  
  const handleModelClose = () => {
    setShowCreateHormoneModal(false);
    setShowCreateDrugModal(false);
    setFocusEvent(null);
    setFocusEventCal(null);
  };

  const handleModelCloseAndReferesh = () => {
    setShowDrugModal(false);
    setShowEventModal(false);
    setFocusEvent(null);
    setFocusEventCal(null);
    setShowFollicularModal(false);
    setShowFollicularImageModal(false);
    setShowHormoneValueModal(false);
    setFocusEvent(null);
    setFocusEventCal(null);
    doRefresh(!refresh);
  };
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Update on load and resize
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
    setVh();
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (id) {
      showLoader();
      getStim(id)
        .then((stim: Stim) => {
          if (isMounted) setSelctedStim(stim);
        })
        .catch(() => {
          if (isMounted) addAlert(t('FailedToFetchStimDetails'), 'error');
        })
        .finally(() => {
          if (isMounted) hideLoader();
        });
    }
    return () => { isMounted = false; };
  }, [id, addAlert, refresh, showLoader, hideLoader]);

  useEffect(() => {
    if (selectedStim?.cycle.cycle_start_date) {
      setFirstDate(convertToLocalDateTime(selectedStim?.cycle.cycle_start_date));
    }

    if (selectedStim?.cycle.cycle_end_date) {
      setEndDate(convertToLocalDateTime(selectedStim?.cycle.cycle_end_date));
    }
  }, [selectedStim]);


  useEffect(() => {
    if (patientId) {
      getTestResults(patientId,id ).then((results: TestResult[])=> {
        const hormoneResources: MbscResource[] = Array.from(
          new Map(
            results.map((result: TestResult) => [
              result.laboratory_test.id,
              {
                id: `hormone-${result.laboratory_test.id}`,
                name: result.laboratory_test.name,
                eventCreation: true,
                eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false
              },
            ])
          ).values()
        );

        setHormone(hormoneResources);
        const hormoneEvents: MbscCalendarEvent[] = results
          .filter((result: TestResult) =>
            firstDate && convertToLocalDateTime(result.date) >= firstDate && (endDate ? convertToLocalDateTime(result.date) <= (endDate) : true)
          )
          .map((result: TestResult) => ({
            resource: `hormone-${result.laboratory_test.id}`,
            name: result.laboratory_test.name,
            title: result.results?.toString() || '+',
            date: convertToLocalDateTime(result.date),
            cssClass: 'hormone',
            id: result.id,
            unit: result.laboratory_test.unit,
          }));

        setHormoneEvents(hormoneEvents);
      });
    }
    if (selectedStim?.medications) {
      const stimDrugs: MbscResource[] = Array.from(
        new Map(
          selectedStim.medications
            .filter((med: StimulationMedication) => med.drug_type === 'STIMULATION') // Filter before mapping
            .map((med: StimulationMedication) => [`stim-${med.drug.id}`, med]) // Use drug.id as the unique key
        ).values()
      ).map((med: StimulationMedication) => ({
        id: `stim-${med.drug.id}`,
        name: med.drug.name,
        eventCreation: editable,
        eventDragInTime: !editable,
        eventDragBetweenSlots: !editable,
        eventDragBetweenResources: false,
        eventResize: editable
      }));
      setStim(stimDrugs);
      const triggerDrugs: MbscResource[] = Array.from(
        new Map(
          selectedStim.medications
            .filter((med: StimulationMedication) => med.drug_type === 'TRIGGER') // Filter before mapping
            .map((med: StimulationMedication) => [`trigger-${med.drug.id}`, med]) // Use drug.id as the unique key
        ).values()
      ).map((med: StimulationMedication) => ({
        id: `trigger-${med.drug.id}`,
        name: med.drug.name,
        eventCreation: editable,
        eventDragInTime: !editable,
        eventDragBetweenSlots: !editable,
        eventDragBetweenResources: false,
        eventResize: editable
      }));
      setTrigger(triggerDrugs);
      const eventsMedStim: MbscCalendarEvent[] = selectedStim?.medications?.filter((med: StimulationMedication) => med.drug_type === 'STIMULATION')
        .map((med: StimulationMedication) => ({
          id: med.id.toString(),
          title: med.quantity.toString(),
          start: convertToLocalDateTime(med.start_date),
          end: convertToLocalDateTime(med.end_date),
          resource: `stim-${med.drug.id}`,
        }));
      setStimEvents(eventsMedStim);
      const eventsMedtrigger: MbscCalendarEvent[] =
        selectedStim?.medications?.filter((med: StimulationMedication) => med.drug_type === 'TRIGGER')
          .map((med: StimulationMedication) => ({
            id: med.id.toString(),
            title: med.quantity.toString(),
            start: convertToLocalDateTime(med.start_date),
            end: convertToLocalDateTime(med.end_date),
            resource: `trigger-${med.drug.id}`,
          }));
      setTriggerEvents(eventsMedtrigger);
    }
    if (selectedStim?.events) {
      const events: MbscCalendarEvent[] = selectedStim?.events?.map((med: StimulationEvent) => ({
        id: med.id,
        title: t(med.event_type), // Localized event type
        date: convertToLocalDateTime(med.date),
        resource: 'Event',
        allDay: true
      }));
      setEvents(events);
    }
    if (selectedStim?.events?.find((e: StimulationEvent) => e.event_type === 'OPU') !== undefined) {
      setOpuAvailable(true)
    }
    if (selectedStim) {
      getFSResults(selectedStim.id)
        .then((res: PaginatedResponse<FollicularStudyResultsList[]>) => res.objects)
        .then((results: FollicularStudyResultsList[]) => {
          const uniqueEventsMap = new Map<string, MbscCalendarEvent>();
          let maxSize = 20; // Default maximum

          results.forEach((result: FollicularStudyResultsList) => {
            // Base events
            const baseEvents = [
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'fs' },
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'fi', title: result.left_ovary_path_url, id: result.id },
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'fd', title: result.details?.toString(), id: result.id },
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'et', title: result.endometrium_thickness || '-' },
            ];

            baseEvents.forEach((event) => {
              const key = `${event.date}-${event.resource}`;
              if (!uniqueEventsMap.has(key)) {
                uniqueEventsMap.set(key, event);
              }
            });
            // Group follicular details
            if (result.details) {
              result.details.forEach((detail: FollicularStudyDetails) => {
                const processDetail = (size: string | null | undefined, count: string | null | undefined, side: 'L' | 'R') => {
                  const numericSize = size ? parseFloat(size) : null;
                  const follicleCount = count ? parseInt(count, 10) : 0;

                  if (numericSize !== null) {
                    // Track maximum size
                    if (numericSize >= 2 && numericSize > maxSize) {
                      maxSize = Math.floor(numericSize);
                    }
                    // Use the numeric size directly as resource ID (rounded down for grouping)
                    const resource = numericSize < 2 ? '<2' : Math.floor(numericSize).toString();
                    const key = `${result.date}-${resource}`;

                    if (!uniqueEventsMap.has(key)) {
                      uniqueEventsMap.set(key, {
                        date: formatDateToLocalYYYYMMDD(new Date(result.date)),
                        resource,
                        title: 'L:0 R:0', // Initialize with compact format
                      });
                    }

                    // Update the respective L or R count
                    const event = uniqueEventsMap.get(key);
                    if (event && event.title) {
                      const match = event.title.match(new RegExp(`${side}:(\\d+)`));
                      const currentCount = match ? parseInt(match[1], 10) : 0;
                      const updatedTitle = event.title.replace(
                        `${side}:${currentCount}`,
                        `${side}:${currentCount + follicleCount}`
                      );
                      event.title = updatedTitle;
                    }
                  }
                };

                processDetail(detail.left_follicle_size, detail.left_no_of_follicles, 'L');
                processDetail(detail.right_follicle_size, detail.right_no_of_follicles, 'R');
              });
            }
          });

          // Convert Map to array and set the state
          const uniqueEvents = Array.from(uniqueEventsMap.values());
          setFollicularStudyEvents(uniqueEvents);
          setMaxFollicleSize(maxSize);

        });
    }
  }, [selectedStim, firstDate, editable]);

  // Generate follicular size children dynamically based on maxFollicleSize
  const follicularSizeChildren = useMemo(() => {
    const children: MbscResource[] = [
      { name: t('Less than 2'), id: '<2', eventCreation: false, eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false }
    ];
    
    for (let i = 2; i <= maxFollicleSize; i++) {
      children.push({
        name: i.toString(),
        id: i.toString(),
        eventCreation: false,
        eventDragInTime: false,
        eventDragBetweenSlots: false,
        eventDragBetweenResources: false,
        eventResize: false
      });
    }
    
    return children;
  }, [maxFollicleSize, t]);

  const myResources: MbscResource[] = [
    {
      name: t('Event'),
      id: 'Event',
      eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false
    },
    {
      name: t('Medication'),
      id: 'Medication',
      collapsed: false,
      isParent: true,
      eventCreation: false,
      children: [
        { name: t('Stim'), id: 'med-stim', children: stim ? stim : [], eventCreation: false },
        { name: t('Trigger'), id: 'med-trigger', children: trigger ? trigger : [], eventCreation: false },
        { name: t('Hormone'), id: 'med-hormone', children: hormone ? hormone : [], eventCreation: false },
      ],
    },
    {
      name: t('Follicular Study'),
      id: 'fs',
      collapsed: false,
      isParent: true,
      eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false,
      children: [
        { name: t('Follicular Image'), id: 'fi', eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
        { name: t('Follicular Details'), id: 'fd', eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
        { name: t('Endometrium Thickness (mm)'), id: 'et', eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
        {
          name: t('Follicular Size (mm)'),
          id: 'fsm',
          collapsed: false,
          eventCreation: false,
          children: [
            ...follicularSizeChildren,
          ],
        },
      ],
    },
  ];

  function handleFollicularDetailsClick(data: MbscCalendarEventData,): void {
    setFocusEventCal(data);
    setFollicularModalMode('view');
    setShowFollicularModal(true);

  }

  function handleFollicularImageClick(data: MbscCalendarEventData): void {
    setFocusEventCal(data);
    setShowFollicularImageModal(true);
  }

  function handleHormonClick(data: MbscCalendarEventData) {
    if (!editable) return;
    setFocusEventCal(data);
    setShowHormoneValueModal(true);
  }

  function handleMedClick(data: MbscCalendarEventData): void {
    if (!editable) return;
    setFocusEventCal(data);
    setShowDrugModal(true);
  }


  function handleScheduleEventRender(data: MbscCalendarEventData) {
    
    if (data?.resource === 'Event') {
      return (<span className={Styles.eventE} onClick={() => { handleEventClick(data); }}>{data.title}</span>);
    }
    if (data?.resource === 'fi') {
      if (data.title) {
        return (<div className={Styles.camera}><Eye onClick={() => handleFollicularImageClick(data)} /></div>);
      }
      return (<div className={Styles.camera}>{<Camera onClick={() => handleFollicularImageClick(data)} />}</div>);
    }
    if (data?.resource === 'fs') {
      
      return (<div className={Styles.camera}><CheckBox /></div>);
    }
    if (data?.resource === 'fd') {
      if (data.title) {
        return (<div className={Styles.camera}><Eye onClick={() => handleFollicularDetailsClick(data)} /></div>);
      }
      return (<div className={Styles.camera}>{editable && <AddCircle onClick={() => handleFollicularStudyModal(data)} />}</div>);
    }
    if (data.resource?.toString().startsWith('hormone-')) {
      return (<span className={Styles.event_hm} onClick={() => handleHormonClick(data)}>{data.title}</span>);
    }
    if (data.resource?.toString().startsWith('trigger-') || data.resource?.toString().startsWith('stim-')) {
      return (<span onClick={() => handleMedClick(data)} className={Styles.event}>{data.title}</span>);
    }
    return (<span className={Styles.event}>{data.title}</span>);
  }



  const handleCreateDrugModelOpen = (name: string) => {
    if (!editable) return;
    // Map translated names to internal keys
    const nameKey = {
      [t('Hormone')]: 'Hormone',
      [t('Stim')]: 'Stim',
      [t('Trigger')]: 'Trigger',
    }[name];

    switch (nameKey) {
      case 'Hormone':
        setShowCreateHormoneModal(true);
        return;
      case 'Stim':
        setType('Stim');
        break;
      case 'Trigger':
        setType('Trigger');
        break;
    }

    setShowCreateDrugModal(true);
  };


  function handleResourceRender(resource: MbscResource, _day?: Date | undefined) {
    if (resource.id?.toString().includes('med-')) {
      return (<Tooltip title={resource.name} placement="top-start"><div className={Styles.medRes}><span className={Styles.resourceNameP}>{resource.name}</span>
        {editable &&
          <IconButton className={Styles.medResIconButton}>
            {resource.name === 'Trigger' && isOpuAvailable ?
              <AddCircle style={{ opacity: 0.5, cursor: 'not-allowed', }} /> :
              <AddCircle onClick={() => resource.name ? handleCreateDrugModelOpen(resource.name) : addAlert('Error', 'error')} />
            }
          </IconButton>}
      </div></Tooltip>);
    }
    if (resource.id?.toString().includes('stim-') || resource.id?.toString().includes('trigger-') || resource.id?.toString().includes('hormone-')) {
      return (<Tooltip title={resource.name} placement="top-start"><div className={Styles.medResClose}><span className={Styles.resourceNameNP}>{resource.name}</span></div></Tooltip>);
    }
    if (resource.isParent) {
      return (<Tooltip title={resource.name} placement="top-start"><span className={Styles.resourceNameP}>{resource.name}</span></Tooltip>);
    }
    return (<Tooltip title={resource.name} placement="top-start"><span className={Styles.resourceNameNP}>{resource.name}</span></Tooltip>);
  }

  function getWeekday(arg0: number): React.ReactNode {
    switch (arg0) {
      case 0: return t('Sun');
      case 1: return t('Mon');
      case 2: return t('Tue');
      case 3: return t('Wed');
      case 4: return t('Thu');
      case 5: return t('Fri');
      case 6: return t('Sat');
    }
  }

  function daysFromFirstDate(date: Date) {
    if (firstDate) {
      return Math.ceil((date.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
    }
    return Math.ceil((date.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) + 1;
  }

  function daysFromLastDate(date: Date) {
    if (endDate) {
      return Math.ceil((date.getTime() - endDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
    }
    return null;
  }


  function handleRenderDay(args: MbscCalendarDayData) {
    const diff = daysFromFirstDate(args.date);
    const diffEnd = daysFromLastDate(args.date);
    return <div {...(diff > 0 && (diffEnd ? (diffEnd * -1) >= -1 : true) ? { className: Styles.custHeaderc } : { className: Styles.custHeader })}>
      {diff > 0 ? <label className={Styles.headDay}>{diff.toString().padStart(2, '0')}</label> : <label className={Styles.headDay}>00</label>}
      <div className={Styles.dayHeader}><label>{args.date.getDate()}</label><span>{getWeekday(args.date.getDay())}</span></div>
    </div>;
  }


  const handleHeaderRender = useCallback(() => {
    return <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <CalendarNav className="cal-header-nav" />
      <div style={{ display: 'flex', flexDirection: 'row' }}>

        {selectedStim && selectedStim.cycle.status === 'ACTIVE' && isEdit !== false  && (canAdd || canEdit) && (

          <div>
            {editable && <Button onClick={() => setEditable(false)} variant="contained" startIcon={<ExitToAppIcon />}>{t('Exit Edit mode')}</Button>}
            {!editable && <Button onClick={() => setEditable(true)} variant="text" startIcon={<EditIcon />}>{t('Edit')}</Button>}
          </div>
        )
        }
        <div>
          {!fullScreen && <Button onClick={() => showFullScreen(true)} variant="text" startIcon={<FullscreenIcon />}>
              {t('Show full screen')}
          </Button>}
          {fullScreen && <Button onClick={() => showFullScreen(false)} variant="text" startIcon={<FullscreenExitIcon />}>
              {t('Exit full screen')}
          </Button>}
        </div>
      </div>
    </div>;
}, [fullScreen, editable, selectedStim]);

  function handleEventClick(data: MbscCalendarEventData) {
    setFocusEventCal(data);
    setShowEventModal(true);
    setIsNewEvent(false);
  }

  function handleEventTypeCreation(): void {
    setShowEventModal(editable && true);
    setIsNewEvent(true);
  }

  function handleDrugCreation() {
    setShowDrugModal(true);
  }

  function handleHormoneTestCreation() {
    setShowHormoneValueModal(true);
  }

  function handleFollicularStudyModal(data: MbscCalendarEventData) {
    setFocusEventCal(data);
    setFollicularModalMode('edit');
    setShowFollicularModal(true);
  }

  ////////////// EXISTING CODEBASE FOR handleFollicularStudyCreation fUNCTION START//////////////

//  function handleFollicularStudyCreation(args: MbscEventCreateEvent) {
//     if (selectedStim && selectedStim.id && focusEvent && focusEvent.event && focusEvent.event.start) {
//       const startDate = focusEvent?.event.start as Date;
//       const endDate = new Date(startDate);  // Clone the original date
//       startDate.setHours(startDate.getHours() + 6);
//       endDate.setHours(endDate.getHours() + 7);
      
//       console.log('Date Original Date:', startDate);
//       console.log('Date After Adding 1 Hour:', endDate);
//       showConfirmationModal({
//         message: 'Are you sure you want to schedule follicular scan?',
//         onConfirm: () => {
//           createEmptyFSDetailResults({
//             stimulation_chart: selectedStim?.id,
//             date: formatDateToLocalYYYYMMDD(focusEvent?.event.start as Date),
//             time: '12:00:00'
//           }).then(() => {
//             return getCurrentUser().then((user: User) => {
//               scheduleFA(
//                 user.id,
//                 formatDateToLocalYYYYMMDD(startDate),
//                 convertDateToISOWithOffset(startDate),
//                 convertDateToISOWithOffset(endDate),
//                 selectedStim.patient.id,
//                 user.clinic_department[0].department_id
//               );
//             });
//           })
//             .then(() => doReferesh(!referesh))
//             .catch(() => addAlert('Failed to schedule follicular scan', 'error'));
//         },
//         onCancel: () => {
//           console.log('Cancelled!');
//         },
//       });
      
//     }
//   }

  ////////////// EXISTING CODEBASE FOR handleFollicularStudyCreation fUNCTION end //////////////

  function handleFollicularStudyCreation(args: MbscEventCreateEvent) {
    if (selectedStim && selectedStim.id && focusEvent && focusEvent.event && focusEvent.event.start) {
      const startDate = focusEvent?.event.start as Date;
      const endDate = new Date(startDate);  // Clone the original date
      startDate.setHours(startDate.getHours() + 6);
      endDate.setHours(endDate.getHours() + 7);

      showConfirmationModal({
        message: t('AreYouSureYouWantToScheduleFollicularScan'),
        onConfirm: async () => {
          showLoader();
          try {

            const fsResult = await createEmptyFSDetailResults({
              stimulation_chart: selectedStim.id,
              date: formatDateToLocalYYYYMMDD(focusEvent.event.start as Date),
              time: '12:00:00'
            });

            addAlert(t('FollicularScanScheduledSuccessfully'), 'success');
            doRefresh(!refresh);
            const user: User = await getCurrentUser();

            try {
              const result = await scheduleFA(
                user.id,
                formatDateToLocalYYYYMMDD(startDate),
                convertDateToISOWithOffset(startDate),
                convertDateToISOWithOffset(endDate),
                selectedStim.patient.id,
                user.clinic_department[0].department_id
              );

              doRefresh(!refresh);
            } catch (scheduleErr) {

              throw scheduleErr;
            }
          } catch (err) {
            // addAlert('Failed to schedule follicular scan', 'error');

          } finally {
            hideLoader();
          }
        },
        onCancel: () => {

        },
      });
    }
  }

  function handleEventCreate(args: MbscEventCreateEvent, inst: EventcalendarBase): void {

    if (!editable) return;
    // if (args.event.start && (args.event.start as Date) <= new Date()) 
    // {
    //   addAlert('Choose a future date', 'error');
    //   return;
    // }
    // Commented for removing restriction for User action on previous dates. B.E will handle the validations.

    if (endDate && args.event.start && (args.event.start as Date) > endDate) {
      addAlert('Cycle ends on ' + convertDateToDDMMYYYY(endDate), 'error');
      return;
    }

    setFocusEvent(args);
    if (args.event.resource === 'Event') {
      handleEventTypeCreation();
    } else if (args.event.resource?.toString().startsWith('stim-') || args.event.resource?.toString().startsWith('trigger-')) {
      handleDrugCreation();
    } else if (args.event.resource?.toString().startsWith('hormone-')) {
      handleHormoneTestCreation();
    } else if (args.event.resource?.toString() === 'fs') {
      handleFollicularStudyCreation(args);
    }
  }

  function handleDrugAddSubmit(id: string, name: string, type: 'Trigger' | 'Stim'): void {
    if (type === 'Stim' && stim) {
      if (!stim.some((entry) => entry.id === `stim-${id}`)) {
        setStim([...(stim || []), { id: `stim-${id}`, name }]);
      } else {
        addAlert(t('StimAlreadyExists'), 'warning');
      }
    }
    if (type === 'Trigger') {
      if (!trigger?.some((entry) => entry.id === `trigger-${id}`)) {
        setTrigger([...(trigger || []), { id: `trigger-${id}`, name }]);
      } else {
        addAlert(t('TriggerAlreadyExists'), 'warning');
      }
    }
  }

  function handleHormoneSubmit(id: string, name: string) {
    if (hormone && !hormone.some((entry) => entry.id === `stim-${id}`)) {
      setHormone([...(hormone || []), { id: `hormone-${id}`, name }]);
    } else {
      addAlert(t('HormoneAlreadyExists'), 'warning');
    }
  }

  const getValidRanges = () => {
    if (firstDate && endDate) {
      return [{ start: firstDate, end: endDate }]; // Enable between fromDate and toDate
    } else if (firstDate) {
      return [{ start: firstDate }]; // Enable from fromDate onward if no toDate
    }
    return []; // Default to no valid range if no dates are provided
  };

  const getInvalidRanges = () => {
    const invalidRanges = [];

    if (firstDate) {
      // Invalid range before `firstDate` (exclusive)
      invalidRanges.push({
        start: new Date(0), // Start from epoch time
        end: new Date(firstDate.getTime() - 24 * 60 * 60 * 1000), // Subtract one day
      });
    }

    if (endDate) {
      // Invalid range after `endDate` (exclusive)
      invalidRanges.push({
        start: convertDateToDDMMYYYY(endDate), // One millisecond after `endDate`
        end: new Date(8640000000000000), // Maximum valid JavaScript date
      });
    }

    return invalidRanges;
  };
  const calculateDays = (start_date: string, end_date: string): string => {
    if (start_date && end_date) {
      const start = convertToLocalDateTime(start_date);
      const end = convertToLocalDateTime(end_date);
      return Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24) + 1).toString();
    }
    return '';
  };

  const handleEventDragEnd = (args: MbscEventDragEvent, inst: EventcalendarBase) => {
    if (args.event.id && args.event.start && args.event.end && selectedStim) {
      getDrugDetails(args.event.id as number).then((med: DrugSchema) => {
        const req: DrugPostRequest = {
          drug: med.drug.id,
          drug_type: med.drug_type,
          quantity: med.quantity,
          stim_chart: selectedStim?.id,
          start_date: formatDateToLocalYYYYMMDD(args.event.start as Date),
          number_of_days: parseInt(calculateDays(args.event.start as string, args.event.end as string)),
          start_time: med.start_time || '00:00:00'
        };
        createDrug(req, med.id)
          .then(() => {
            addAlert(t('UpdatedMedicationSuccessfully'), 'success');
            doRefresh(!refresh);
          })
          .catch(() => addAlert(t('FailedToUpdateMedication'), 'error'));
      }).catch((error) => {
        console.error('Error fetching drug details:', error);
        addAlert(t('FailedToUpdateMedication'), 'error');
      });
    }
  };

  // Tooltip Functionality Start
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);
  const [tooltipAnchor, setTooltipAnchor] = useState();
  const [tooltipData, setTooltipData] = useState<MbscCalendarEvent>({});

  const timer = useRef<ReturnType<typeof setTimeout>>();
  const openTooltip = useCallback((args: MbscEventClickEvent) => {
    const event: MbscCalendarEvent = args.event;
    // Only open tooltip if title is a number (not '+')
    if (
      typeof event.title === 'string' &&
      !isNaN(Number(event.title)) &&
      event.title.trim() !== '' &&
      event.title !== '+'
    ) {
      // For stim/trigger, fetch start_time from medication details
      if (
        typeof event.resource === 'string' &&
        (event.resource.toLowerCase().startsWith('stim-') || event.resource.toLowerCase().startsWith('trigger-'))
      ) {
        // Extract medication id from event.id
        const medId = event.id ? parseInt(event.id.toString()) : null;
        if (medId) {
          getDrugDetails(medId).then((med: DrugSchema) => {
            setTooltipData({
              ...event,
              start_time: med.start_time || '',
            });
          });
        } else {
          setTooltipData({ ...event });
        }
      } else {
        setTooltipData({ ...event });
      }
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = undefined;
      }
      setTooltipAnchor(args.domEvent.target.closest('.mbsc-timeline-event'));
      setIsTooltipOpen(
        typeof event.resource === 'string' &&
        (event.resource.toLowerCase().startsWith('hormone-') ||
          event.resource.toLowerCase().startsWith('stim-') ||
          event.resource.toLowerCase().startsWith('trigger-'))
      );
    }
  }, []);

  const handleEventHoverIn = useCallback(
    (args: MbscEventClickEvent) => {
      openTooltip(args);
    },
    [openTooltip],
  );

  const handleEventHoverOut = useCallback(() => {
    if (!timer.current) {
      timer.current = setTimeout(() => {
        setIsTooltipOpen(false);
      }, 500);
    }
  }, []);

  const handleMouseEnter = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = undefined;
    }
  }, []);

  const handleMouseLeave = useCallback(() => {
    timer.current = setTimeout(() => {
      setIsTooltipOpen(false);
    }, 500);
  }, []);

  const handleTooltipClose = useCallback(() => {
    setIsTooltipOpen(false);
  }, []);

  const handleToolTipEdit = (type: string) => {
    setEditable(true);
    if (type.startsWith('hormone-')) {
      handleHormonClick(tooltipData as unknown as MbscCalendarEventData);
    } else if (type.startsWith('stim-')) {
      handleMedClick(tooltipData as unknown as MbscCalendarEventData);
    } else if (type.startsWith('trigger-')) {
      handleMedClick(tooltipData as unknown as MbscCalendarEventData);
    }
    handleTooltipClose();
  };
  const handleToolTipDelete = (type: string) => {
    if (type.startsWith('stim-')) {
      const deleteID = tooltipData.id ? parseInt(tooltipData.id.toString()) : 0;
      showConfirmationModal({
        message: t('AreYouSureYouWantToDeleteMedication'),
        Title: t('Stim_Drugs'), 
        onConfirm: () => {
          deleteMed(deleteID)
            .then(() => addAlert(t('DeletedStimMedication'), 'success'))
            .catch((error: any) => {
              addAlert(error?.response?.data?.errors[0]?.detail || t('FailedToDeleteMedication'), 'error');
            })
            .finally(() => {
              handleModelClose();
              doRefresh(!refresh);
            });
        },
        onCancel: () => {
          setShowEventModal(false);
        },
      });
    } else if (type.startsWith('trigger-')) {
      const deleteID = tooltipData.id ? parseInt(tooltipData.id.toString()) : 0;
      showConfirmationModal({
        message: t('AreYouSureYouWantToDeleteMedication'),
        Title: t('Trigger_Drugs'),
        onConfirm: () => {
          deleteMed(deleteID)
            .then(() => addAlert(t('DeletedTriggerMedication'), 'success'))
            .catch((error: any) => {
              addAlert(error?.response?.data?.errors[0]?.detail || t('FailedToDeleteMedication'), 'error');
            })
            .finally(() => {
              handleModelClose();
              doRefresh(!refresh);
            });
        },
        onCancel: () => {
          setShowEventModal(false);
        },
      });
    }
    else if (type.startsWith('hormone-')) {
      const deleteID = tooltipData.id ? parseInt(tooltipData.id.toString()) : 0;
      showConfirmationModal({
        message: t('AreYouSureYouWantToDeleteHormone'),
        Title: t('Hormone_Test'),
        onConfirm: () => {
          deleteHormone(deleteID)
            .then(() => addAlert(t('DeletedHormone'), 'success'))
            .catch((error: any) => {
              addAlert(error?.response?.data?.errors[0]?.detail || t('FailedToDeleteHormone'), 'error');
            })
            .finally(() => {
              handleModelClose();
              doRefresh(!refresh);
            });
        },
        onCancel: () => {
          setShowEventModal(false);
        },
      });
    }
    handleTooltipClose();
  };

  // Tooltip Functionality End

  function formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  

  if (selectedStim && canView) {
    return (<div {...(fullScreen ? { className: Styles.fullscreen } : { className: Styles.exitFullscreen })}>
  {showFolliculareImageModal && focusEventCal && <FollicularImageModal editable={editable && (canEdit || canAdd)} date={focusEventCal.startDate} cycleId={selectedStim.cycle.id} patient={patientId} id={focusEventCal.id} open={showFolliculareImageModal} onClose={handleModelCloseAndReferesh} stimId={selectedStim.id} />}
      {selectedStim && selectedStim.id && editable && showHormoneValueModal && (focusEvent && focusEvent?.event.resource?.toString().split('-')[1] && focusEvent.event.start || focusEventCal?.title && focusEventCal.id) && <HormoneValueModal value={focusEventCal?.title} id={focusEventCal?.id} cycle={selectedStim.cycle.id} selected_stim={selectedStim.id} patientId={patientId} unit={(focusEventCal as any)?.original?.unit || (focusEventCal as any)?.unit} {
        ...(focusEvent?.event.start
          ? { date: new Date(focusEvent.event.start.toString()) }
          : focusEventCal?.startDate
            ? { date: new Date(focusEventCal.startDate) }
            : focusEventCal?.date
              ? { date: new Date(focusEventCal.date) }
              : {})
      } {
        ...(focusEvent?.event.resource?.toString().split('-')[1]
          ? { hormoneId: parseInt(focusEvent?.event.resource?.toString().split('-')[1]) }
          : focusEventCal?.resource && { hormoneId: parseInt(focusEventCal?.resource?.toString().split('-')[1]) })
        } hormonesModalOpen={showHormoneValueModal} handleHormonesModalClose={handleModelCloseAndReferesh} />}
      {showCreateDrugModal && type && <CreateDrugModal handleDrugModalClose={handleModelClose} handleSubmitClose={handleDrugAddSubmit} drugModalOpen={showCreateDrugModal} type={type} />}
      {showDrugModal && (focusEvent || focusEventCal) && (focusEvent?.event.resource || focusEventCal?.resource) && (focusEvent?.event.start || focusEventCal?.start) && <AddDrugModal medId={focusEventCal?.id} type={focusEvent?.event?.resource?.toString().split('-')[0] || focusEventCal?.resource?.toString().split('-')[0]} id={focusEvent?.event?.resource?.toString().split('-')[1] || focusEventCal?.resource?.toString().split('-')[1]} drugModalOpen={showDrugModal} handleDrugModalClose={handleModelCloseAndReferesh} stim={selectedStim.id} date={new Date(focusEvent?.event?.start?.toString() || focusEventCal?.start?.toString() || new Date())} />}
      {showEventModal && (focusEventCal || focusEvent) && <EventModel id={focusEventCal?.id} stim={selectedStim.id} patient={selectedStim.patient.id} partner={selectedStim.patient.partner?.id} scheduleEventModalOpen={showEventModal} handleScheduleModalClose={handleModelCloseAndReferesh} {...(focusEvent?.event.start && { eventDate: new Date(focusEvent?.event.start.toString()) })} isNewEvent={!isNewEvent} editable={editable} />}
      {showCreateHormoneModal && <CreateHormoneModal handleHormoneModalClose={handleModelClose} hormoneModalOpen={showCreateHormoneModal} handleSubmitClose={handleHormoneSubmit} />}
      {showFolliculareModal && focusEventCal && focusEventCal.startDate && <FolliculerModal editable={editable && (canEdit || canAdd)} id={focusEventCal.id} cycleDay={daysFromFirstDate(new Date(focusEventCal.startDate.toString()))} {...(selectedStim.cycle.lmp_date && { lmp: new Date(selectedStim.cycle.lmp_date) })} date={new Date(focusEventCal.startDate.toString())} stim={selectedStim.id} cycleStatus={selectedStim.cycle.status} handleHormoneModalClose={handleModelCloseAndReferesh} hormoneModalOpen={showFolliculareModal} />}
      <Eventcalendar
        onEventDragEnd={handleEventDragEnd}
        invalid={getInvalidRanges()}
        onEventCreate={handleEventCreate}
        renderHeader={handleHeaderRender}
        {...(firstDate && { refDate: firstDate })}
        showControls={true}
        renderDay={handleRenderDay}
        dragToResize={editable}
        renderScheduleEvent={handleScheduleEventRender}
        renderResource={handleResourceRender}
        dragBetweenResources={false}
        dragToMove={editable}
        dragBetweenSlots={editable}
        resources={myResources}
        clickToCreate={editable}
        data={[...(events || []), ...(stimEvents || []), ...(triggerEvents || []), ...(hormoneEvents || []), ...(follicularDetailsEvents || []), ...(follicularETEvents || []), ...(follicularImageEvents || []), ...(follicularStudyEvents || []), ...(follicularSizeEvents || [])]}
        {...(fullScreen ? { height: '100vh' } : height && { height: height })}
        {...(fullScreen && { width: '100%' })}
        view={{
          timeline: {
            virtualScroll: true,
            eventList: true,
            rowHeight: 'variable',
            type: 'month',
            resolutionHorizontal: 'day', // Full-day resolution
            timeCellStep: 1440, // Each cell represents 1 day
          },
        }}
        showEventTooltip={false}
        onEventHoverIn={handleEventHoverIn}
        onEventHoverOut={handleEventHoverOut}
        selectedDate={selectionDate ?? selectedStim.cycle.cycle_start_date}
        defaultSelectedDate={selectionDate ?? selectedStim.cycle.cycle_start_date}
        onSelectedDateChange={(e) => setSelectionDate(formatDateToYYYYMMDD(new Date(String(e.date))))}
      />
      <Popup
        anchor={tooltipAnchor}
        contentPadding={false}
        display="anchored"
        isOpen={isTooltipOpen}
        scrollLock={false}
        showOverlay={false}
        touchUi={false}
        onClose={handleTooltipClose}
      >
        <Box bgcolor={'white'} p={2} borderRadius={2} boxShadow={2} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            {tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ?
              <Typography variant='body2' color="textSecondary">
                {t('Dose')}
                <Typography variant="body1" color="textSecondary" fontWeight="bold">{tooltipData?.title}</Typography>
              </Typography> :
              <Typography variant="h6" fontWeight="bold"  >
                {t('Hormones')}
              </Typography>}
            {editable && <Box pl={2}>
              <IconButton
                size="small"
                onClick={() => handleToolTipDelete(tooltipData.resource?.toString() ?? '')}
              >
                <DeleteOutlineIcon sx={{ fill: 'textSecondary' }} />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => handleToolTipEdit(tooltipData.resource?.toString() ?? '')}
              >
                {/* <BorderColorOutlinedIcon sx={{fill:'textSecondary'}}/> */}
                <img
                  src={Editicon}
                  alt="Edit"
                  style={{ width: 20, height: 20 }}
                />
              </IconButton>
            </Box>}
          </Box>

          <Box display={'flex'} justifyContent={'flex-start'} mt={1}>
            <Typography variant="body2" color="textSecondary">

              {tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? t('DrugTime') : t('HormoneValue')}
              <Typography variant="body1" fontWeight="bold">{tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? convertUTCToLocalTime(tooltipData.start_time) : tooltipData?.title}</Typography>
            </Typography>
            <Typography variant="body2" color="textSecondary" ml={4}>
              {tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? t('Days') : t('Unit')}
              <Typography variant="body1" fontWeight="bold">{tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? getNumberOfDays(tooltipData.start ?? '', tooltipData.end ?? '').days : tooltipData?.unit ?? ''}</Typography>
            </Typography>
          </Box>
        </Box>
      </Popup>
    </div>);
  } else {
    return <DefaultLoader />;
  }
};